import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=5131a49c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5131a49c')) {
      api.createRecord('5131a49c', component.options)
    } else {
      api.reload('5131a49c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=5131a49c&", function () {
      api.rerender('5131a49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKG2OPqc1T14/JS/offershelp.vue"
export default component.exports